'use client';

import { useRef, useMemo, useEffect } from "react";
import { useLiveAnnouncement } from "../../../utils/hooks/useLiveAnnouncement.js";
import { loadingStartMsg, loadingEndMsg } from "../Select.data.js";
import { selectAnnouncementOptions } from "./constants.js";
function useAnnouncementForLoading({
  isLoading
}) {
  const bareAnnounce = useLiveAnnouncement();
  const isLoadingStartedRef = useRef(false);
  const announce = useMemo(
    () => (loading = false) => {
      if (loading) {
        isLoadingStartedRef.current = true;
        return bareAnnounce(loadingStartMsg, selectAnnouncementOptions);
      }
      isLoadingStartedRef.current = false;
      return bareAnnounce(loadingEndMsg, selectAnnouncementOptions);
    },
    [bareAnnounce]
  );
  useEffect(() => {
    announce(isLoading);
  }, [announce, isLoading]);
}
export {
  useAnnouncementForLoading
};
